module.exports = __webpack_public_path__ + "static/metal02-2956bc05ca7429202f9b60e37427514f.png";